module.exports = __webpack_public_path__ + "img/pin-plus.eed44e9a.svg";